import { Component } from '@angular/core';

@Component({
  selector: 'app-notification-header',
  templateUrl: './notification-header.component.html',
  styleUrls: ['./notification-header.component.scss'],
})
export class NotificationHeaderComponent {}
